import React from "react";
import { ValidationError } from "@formspree/react";

export default function FormField({
  id,
  name = id,
  label,
  type = "text",
  as = "input",
  errors,
  help,
  className = "",
  children,
  required = true,
  ...props
}) {
  const Control = as;
  const hasError = Boolean(errors?.getFieldErrors?.(name)?.length);
  const describedBy =
    [help && `${id}-help`, hasError && `${id}-error`]
      .filter(Boolean)
      .join(" ") || undefined;
  return (
    <div className={`form-field ${className}`}>
      <label htmlFor={id}>
        {label}
        {!required && <span className="optional-label"> (optional)</span>}
      </label>
      <Control
        id={id}
        name={name}
        type={as === "input" ? type : undefined}
        required={required}
        aria-invalid={hasError || undefined}
        aria-describedby={describedBy}
        {...props}
      >
        {children}
      </Control>
      {help && (
        <p id={`${id}-help`} className="form-help">
          {help}
        </p>
      )}
      <ValidationError
        id={`${id}-error`}
        prefix={label}
        field={name}
        errors={errors}
        role="alert"
      />
    </div>
  );
}
